export interface PhoneCountry {
  name: string;
  iso2: string;
  dialCode: string;
}

export const PHONE_COUNTRIES: PhoneCountry[] = [
  { name: 'Afghanistan', iso2: 'AF', dialCode: '+93' },
  { name: 'Albania', iso2: 'AL', dialCode: '+355' },
  { name: 'Algeria', iso2: 'DZ', dialCode: '+213' },
  { name: 'American Samoa', iso2: 'AS', dialCode: '+1684' },
  { name: 'Andorra', iso2: 'AD', dialCode: '+376' },
  { name: 'Angola', iso2: 'AO', dialCode: '+244' },
  { name: 'Anguilla', iso2: 'AI', dialCode: '+1264' },
  { name: 'Antarctica', iso2: 'AQ', dialCode: '+672' },
  { name: 'Antigua and Barbuda', iso2: 'AG', dialCode: '+1268' },
  { name: 'Argentina', iso2: 'AR', dialCode: '+54' },
  { name: 'Armenia', iso2: 'AM', dialCode: '+374' },
  { name: 'Aruba', iso2: 'AW', dialCode: '+297' },
  { name: 'Australia', iso2: 'AU', dialCode: '+61' },
  { name: 'Austria', iso2: 'AT', dialCode: '+43' },
  { name: 'Azerbaijan', iso2: 'AZ', dialCode: '+994' },
  { name: 'Bahamas', iso2: 'BS', dialCode: '+1242' },
  { name: 'Bahrain', iso2: 'BH', dialCode: '+973' },
  { name: 'Bangladesh', iso2: 'BD', dialCode: '+880' },
  { name: 'Barbados', iso2: 'BB', dialCode: '+1246' },
  { name: 'Belarus', iso2: 'BY', dialCode: '+375' },
  { name: 'Belgium', iso2: 'BE', dialCode: '+32' },
  { name: 'Belize', iso2: 'BZ', dialCode: '+501' },
  { name: 'Benin', iso2: 'BJ', dialCode: '+229' },
  { name: 'Bermuda', iso2: 'BM', dialCode: '+1441' },
  { name: 'Bhutan', iso2: 'BT', dialCode: '+975' },
  { name: 'Bolivia', iso2: 'BO', dialCode: '+591' },
  { name: 'Bosnia and Herzegovina', iso2: 'BA', dialCode: '+387' },
  { name: 'Botswana', iso2: 'BW', dialCode: '+267' },
  { name: 'Brazil', iso2: 'BR', dialCode: '+55' },
  { name: 'British Indian Ocean Territory', iso2: 'IO', dialCode: '+246' },
  { name: 'British Virgin Islands', iso2: 'VG', dialCode: '+1284' },
  { name: 'Brunei', iso2: 'BN', dialCode: '+673' },
  { name: 'Bulgaria', iso2: 'BG', dialCode: '+359' },
  { name: 'Burkina Faso', iso2: 'BF', dialCode: '+226' },
  { name: 'Burundi', iso2: 'BI', dialCode: '+257' },
  { name: 'Cabo Verde', iso2: 'CV', dialCode: '+238' },
  { name: 'Cambodia', iso2: 'KH', dialCode: '+855' },
  { name: 'Cameroon', iso2: 'CM', dialCode: '+237' },
  { name: 'Canada', iso2: 'CA', dialCode: '+1' },
  { name: 'Caribbean Netherlands', iso2: 'BQ', dialCode: '+599' },
  { name: 'Cayman Islands', iso2: 'KY', dialCode: '+1345' },
  { name: 'Central African Republic', iso2: 'CF', dialCode: '+236' },
  { name: 'Chad', iso2: 'TD', dialCode: '+235' },
  { name: 'Chile', iso2: 'CL', dialCode: '+56' },
  { name: 'China', iso2: 'CN', dialCode: '+86' },
  { name: 'Christmas Island', iso2: 'CX', dialCode: '+61' },
  { name: 'Cocos Islands', iso2: 'CC', dialCode: '+61' },
  { name: 'Colombia', iso2: 'CO', dialCode: '+57' },
  { name: 'Comoros', iso2: 'KM', dialCode: '+269' },
  { name: 'Congo', iso2: 'CG', dialCode: '+242' },
  { name: 'Congo Democratic Republic', iso2: 'CD', dialCode: '+243' },
  { name: 'Cook Islands', iso2: 'CK', dialCode: '+682' },
  { name: 'Costa Rica', iso2: 'CR', dialCode: '+506' },
  { name: "Cote d'Ivoire", iso2: 'CI', dialCode: '+225' },
  { name: 'Croatia', iso2: 'HR', dialCode: '+385' },
  { name: 'Cuba', iso2: 'CU', dialCode: '+53' },
  { name: 'Curacao', iso2: 'CW', dialCode: '+599' },
  { name: 'Cyprus', iso2: 'CY', dialCode: '+357' },
  { name: 'Czech Republic', iso2: 'CZ', dialCode: '+420' },
  { name: 'Denmark', iso2: 'DK', dialCode: '+45' },
  { name: 'Djibouti', iso2: 'DJ', dialCode: '+253' },
  { name: 'Dominica', iso2: 'DM', dialCode: '+1767' },
  { name: 'Dominican Republic', iso2: 'DO', dialCode: '+1' },
  { name: 'Ecuador', iso2: 'EC', dialCode: '+593' },
  { name: 'Egypt', iso2: 'EG', dialCode: '+20' },
  { name: 'El Salvador', iso2: 'SV', dialCode: '+503' },
  { name: 'Equatorial Guinea', iso2: 'GQ', dialCode: '+240' },
  { name: 'Eritrea', iso2: 'ER', dialCode: '+291' },
  { name: 'Estonia', iso2: 'EE', dialCode: '+372' },
  { name: 'Eswatini', iso2: 'SZ', dialCode: '+268' },
  { name: 'Ethiopia', iso2: 'ET', dialCode: '+251' },
  { name: 'Falkland Islands', iso2: 'FK', dialCode: '+500' },
  { name: 'Faroe Islands', iso2: 'FO', dialCode: '+298' },
  { name: 'Fiji', iso2: 'FJ', dialCode: '+679' },
  { name: 'Finland', iso2: 'FI', dialCode: '+358' },
  { name: 'France', iso2: 'FR', dialCode: '+33' },
  { name: 'French Guiana', iso2: 'GF', dialCode: '+594' },
  { name: 'French Polynesia', iso2: 'PF', dialCode: '+689' },
  { name: 'Gabon', iso2: 'GA', dialCode: '+241' },
  { name: 'Gambia', iso2: 'GM', dialCode: '+220' },
  { name: 'Georgia', iso2: 'GE', dialCode: '+995' },
  { name: 'Germany', iso2: 'DE', dialCode: '+49' },
  { name: 'Ghana', iso2: 'GH', dialCode: '+233' },
  { name: 'Gibraltar', iso2: 'GI', dialCode: '+350' },
  { name: 'Greece', iso2: 'GR', dialCode: '+30' },
  { name: 'Greenland', iso2: 'GL', dialCode: '+299' },
  { name: 'Grenada', iso2: 'GD', dialCode: '+1473' },
  { name: 'Guadeloupe', iso2: 'GP', dialCode: '+590' },
  { name: 'Guam', iso2: 'GU', dialCode: '+1671' },
  { name: 'Guatemala', iso2: 'GT', dialCode: '+502' },
  { name: 'Guernsey', iso2: 'GG', dialCode: '+44' },
  { name: 'Guinea', iso2: 'GN', dialCode: '+224' },
  { name: 'Guinea-Bissau', iso2: 'GW', dialCode: '+245' },
  { name: 'Guyana', iso2: 'GY', dialCode: '+592' },
  { name: 'Haiti', iso2: 'HT', dialCode: '+509' },
  { name: 'Honduras', iso2: 'HN', dialCode: '+504' },
  { name: 'Hong Kong', iso2: 'HK', dialCode: '+852' },
  { name: 'Hungary', iso2: 'HU', dialCode: '+36' },
  { name: 'Iceland', iso2: 'IS', dialCode: '+354' },
  { name: 'India', iso2: 'IN', dialCode: '+91' },
  { name: 'Indonesia', iso2: 'ID', dialCode: '+62' },
  { name: 'Iran', iso2: 'IR', dialCode: '+98' },
  { name: 'Iraq', iso2: 'IQ', dialCode: '+964' },
  { name: 'Ireland', iso2: 'IE', dialCode: '+353' },
  { name: 'Isle of Man', iso2: 'IM', dialCode: '+44' },
  { name: 'Israel', iso2: 'IL', dialCode: '+972' },
  { name: 'Italy', iso2: 'IT', dialCode: '+39' },
  { name: 'Jamaica', iso2: 'JM', dialCode: '+1876' },
  { name: 'Japan', iso2: 'JP', dialCode: '+81' },
  { name: 'Jersey', iso2: 'JE', dialCode: '+44' },
  { name: 'Jordan', iso2: 'JO', dialCode: '+962' },
  { name: 'Kazakhstan', iso2: 'KZ', dialCode: '+7' },
  { name: 'Kenya', iso2: 'KE', dialCode: '+254' },
  { name: 'Kiribati', iso2: 'KI', dialCode: '+686' },
  { name: 'Kosovo', iso2: 'XK', dialCode: '+383' },
  { name: 'Kuwait', iso2: 'KW', dialCode: '+965' },
  { name: 'Kyrgyzstan', iso2: 'KG', dialCode: '+996' },
  { name: 'Laos', iso2: 'LA', dialCode: '+856' },
  { name: 'Latvia', iso2: 'LV', dialCode: '+371' },
  { name: 'Lebanon', iso2: 'LB', dialCode: '+961' },
  { name: 'Lesotho', iso2: 'LS', dialCode: '+266' },
  { name: 'Liberia', iso2: 'LR', dialCode: '+231' },
  { name: 'Libya', iso2: 'LY', dialCode: '+218' },
  { name: 'Liechtenstein', iso2: 'LI', dialCode: '+423' },
  { name: 'Lithuania', iso2: 'LT', dialCode: '+370' },
  { name: 'Luxembourg', iso2: 'LU', dialCode: '+352' },
  { name: 'Macau', iso2: 'MO', dialCode: '+853' },
  { name: 'Madagascar', iso2: 'MG', dialCode: '+261' },
  { name: 'Malawi', iso2: 'MW', dialCode: '+265' },
  { name: 'Malaysia', iso2: 'MY', dialCode: '+60' },
  { name: 'Maldives', iso2: 'MV', dialCode: '+960' },
  { name: 'Mali', iso2: 'ML', dialCode: '+223' },
  { name: 'Malta', iso2: 'MT', dialCode: '+356' },
  { name: 'Marshall Islands', iso2: 'MH', dialCode: '+692' },
  { name: 'Martinique', iso2: 'MQ', dialCode: '+596' },
  { name: 'Mauritania', iso2: 'MR', dialCode: '+222' },
  { name: 'Mauritius', iso2: 'MU', dialCode: '+230' },
  { name: 'Mayotte', iso2: 'YT', dialCode: '+262' },
  { name: 'Mexico', iso2: 'MX', dialCode: '+52' },
  { name: 'Micronesia', iso2: 'FM', dialCode: '+691' },
  { name: 'Moldova', iso2: 'MD', dialCode: '+373' },
  { name: 'Monaco', iso2: 'MC', dialCode: '+377' },
  { name: 'Mongolia', iso2: 'MN', dialCode: '+976' },
  { name: 'Montenegro', iso2: 'ME', dialCode: '+382' },
  { name: 'Montserrat', iso2: 'MS', dialCode: '+1664' },
  { name: 'Morocco', iso2: 'MA', dialCode: '+212' },
  { name: 'Mozambique', iso2: 'MZ', dialCode: '+258' },
  { name: 'Myanmar', iso2: 'MM', dialCode: '+95' },
  { name: 'Namibia', iso2: 'NA', dialCode: '+264' },
  { name: 'Nauru', iso2: 'NR', dialCode: '+674' },
  { name: 'Nepal', iso2: 'NP', dialCode: '+977' },
  { name: 'Netherlands', iso2: 'NL', dialCode: '+31' },
  { name: 'New Caledonia', iso2: 'NC', dialCode: '+687' },
  { name: 'New Zealand', iso2: 'NZ', dialCode: '+64' },
  { name: 'Nicaragua', iso2: 'NI', dialCode: '+505' },
  { name: 'Niger', iso2: 'NE', dialCode: '+227' },
  { name: 'Nigeria', iso2: 'NG', dialCode: '+234' },
  { name: 'Niue', iso2: 'NU', dialCode: '+683' },
  { name: 'Norfolk Island', iso2: 'NF', dialCode: '+672' },
  { name: 'North Korea', iso2: 'KP', dialCode: '+850' },
  { name: 'North Macedonia', iso2: 'MK', dialCode: '+389' },
  { name: 'Northern Mariana Islands', iso2: 'MP', dialCode: '+1670' },
  { name: 'Norway', iso2: 'NO', dialCode: '+47' },
  { name: 'Oman', iso2: 'OM', dialCode: '+968' },
  { name: 'Pakistan', iso2: 'PK', dialCode: '+92' },
  { name: 'Palau', iso2: 'PW', dialCode: '+680' },
  { name: 'Palestine', iso2: 'PS', dialCode: '+970' },
  { name: 'Panama', iso2: 'PA', dialCode: '+507' },
  { name: 'Papua New Guinea', iso2: 'PG', dialCode: '+675' },
  { name: 'Paraguay', iso2: 'PY', dialCode: '+595' },
  { name: 'Peru', iso2: 'PE', dialCode: '+51' },
  { name: 'Philippines', iso2: 'PH', dialCode: '+63' },
  { name: 'Pitcairn Islands', iso2: 'PN', dialCode: '+64' },
  { name: 'Poland', iso2: 'PL', dialCode: '+48' },
  { name: 'Portugal', iso2: 'PT', dialCode: '+351' },
  { name: 'Puerto Rico', iso2: 'PR', dialCode: '+1' },
  { name: 'Qatar', iso2: 'QA', dialCode: '+974' },
  { name: 'Reunion', iso2: 'RE', dialCode: '+262' },
  { name: 'Romania', iso2: 'RO', dialCode: '+40' },
  { name: 'Russia', iso2: 'RU', dialCode: '+7' },
  { name: 'Rwanda', iso2: 'RW', dialCode: '+250' },
  { name: 'Saint Barthelemy', iso2: 'BL', dialCode: '+590' },
  { name: 'Saint Helena', iso2: 'SH', dialCode: '+290' },
  { name: 'Saint Kitts and Nevis', iso2: 'KN', dialCode: '+1869' },
  { name: 'Saint Lucia', iso2: 'LC', dialCode: '+1758' },
  { name: 'Saint Martin', iso2: 'MF', dialCode: '+590' },
  { name: 'Saint Pierre and Miquelon', iso2: 'PM', dialCode: '+508' },
  { name: 'Saint Vincent and the Grenadines', iso2: 'VC', dialCode: '+1784' },
  { name: 'Samoa', iso2: 'WS', dialCode: '+685' },
  { name: 'San Marino', iso2: 'SM', dialCode: '+378' },
  { name: 'Sao Tome and Principe', iso2: 'ST', dialCode: '+239' },
  { name: 'Saudi Arabia', iso2: 'SA', dialCode: '+966' },
  { name: 'Senegal', iso2: 'SN', dialCode: '+221' },
  { name: 'Serbia', iso2: 'RS', dialCode: '+381' },
  { name: 'Seychelles', iso2: 'SC', dialCode: '+248' },
  { name: 'Sierra Leone', iso2: 'SL', dialCode: '+232' },
  { name: 'Singapore', iso2: 'SG', dialCode: '+65' },
  { name: 'Sint Maarten', iso2: 'SX', dialCode: '+1721' },
  { name: 'Slovakia', iso2: 'SK', dialCode: '+421' },
  { name: 'Slovenia', iso2: 'SI', dialCode: '+386' },
  { name: 'Solomon Islands', iso2: 'SB', dialCode: '+677' },
  { name: 'Somalia', iso2: 'SO', dialCode: '+252' },
  { name: 'South Africa', iso2: 'ZA', dialCode: '+27' },
  { name: 'South Korea', iso2: 'KR', dialCode: '+82' },
  { name: 'South Sudan', iso2: 'SS', dialCode: '+211' },
  { name: 'Spain', iso2: 'ES', dialCode: '+34' },
  { name: 'Sri Lanka', iso2: 'LK', dialCode: '+94' },
  { name: 'Sudan', iso2: 'SD', dialCode: '+249' },
  { name: 'Suriname', iso2: 'SR', dialCode: '+597' },
  { name: 'Svalbard and Jan Mayen', iso2: 'SJ', dialCode: '+47' },
  { name: 'Sweden', iso2: 'SE', dialCode: '+46' },
  { name: 'Switzerland', iso2: 'CH', dialCode: '+41' },
  { name: 'Syria', iso2: 'SY', dialCode: '+963' },
  { name: 'Taiwan', iso2: 'TW', dialCode: '+886' },
  { name: 'Tajikistan', iso2: 'TJ', dialCode: '+992' },
  { name: 'Tanzania', iso2: 'TZ', dialCode: '+255' },
  { name: 'Thailand', iso2: 'TH', dialCode: '+66' },
  { name: 'Timor-Leste', iso2: 'TL', dialCode: '+670' },
  { name: 'Togo', iso2: 'TG', dialCode: '+228' },
  { name: 'Tokelau', iso2: 'TK', dialCode: '+690' },
  { name: 'Tonga', iso2: 'TO', dialCode: '+676' },
  { name: 'Trinidad and Tobago', iso2: 'TT', dialCode: '+1868' },
  { name: 'Tunisia', iso2: 'TN', dialCode: '+216' },
  { name: 'Turkey', iso2: 'TR', dialCode: '+90' },
  { name: 'Turkmenistan', iso2: 'TM', dialCode: '+993' },
  { name: 'Turks and Caicos Islands', iso2: 'TC', dialCode: '+1649' },
  { name: 'Tuvalu', iso2: 'TV', dialCode: '+688' },
  { name: 'Uganda', iso2: 'UG', dialCode: '+256' },
  { name: 'Ukraine', iso2: 'UA', dialCode: '+380' },
  { name: 'United Arab Emirates', iso2: 'AE', dialCode: '+971' },
  { name: 'United Kingdom', iso2: 'GB', dialCode: '+44' },
  { name: 'United States', iso2: 'US', dialCode: '+1' },
  { name: 'Uruguay', iso2: 'UY', dialCode: '+598' },
  { name: 'Uzbekistan', iso2: 'UZ', dialCode: '+998' },
  { name: 'Vanuatu', iso2: 'VU', dialCode: '+678' },
  { name: 'Vatican City', iso2: 'VA', dialCode: '+379' },
  { name: 'Venezuela', iso2: 'VE', dialCode: '+58' },
  { name: 'Vietnam', iso2: 'VN', dialCode: '+84' },
  { name: 'Wallis and Futuna', iso2: 'WF', dialCode: '+681' },
  { name: 'Western Sahara', iso2: 'EH', dialCode: '+212' },
  { name: 'Yemen', iso2: 'YE', dialCode: '+967' },
  { name: 'Zambia', iso2: 'ZM', dialCode: '+260' },
  { name: 'Zimbabwe', iso2: 'ZW', dialCode: '+263' },
];

// ISO 3166-1 alpha-2 — usado para el selector de **dial code** de teléfonos (es la convención del estándar internacional para teléfonos).
export const DEFAULT_PHONE_COUNTRY_ISO = 'CL';

// ISO 3166-1 alpha-3 — usado para el campo **country del firmante** (signer.country) que se envía
// al backend para SIMPLEX/DACTILAR. Tras la migración de Phase 2, el backend espera alpha-3.
export const DEFAULT_SIGNER_COUNTRY_ISO3 = 'CHL';

// Mapping mínimo iso-2 → iso-3 para los países que TuFirma soporta como mercado.
// Se usa para convertir entre el campo del phone selector (iso2) y el campo signer country (iso3).
export const ISO2_TO_ISO3: Record<string, string> = {
  CL: 'CHL',
  PE: 'PER',
  CO: 'COL',
  MX: 'MEX',
  AR: 'ARG',
  EC: 'ECU',
  UY: 'URY',
  BR: 'BRA',
  PA: 'PAN',
  CR: 'CRI',
};

export const SUPPORTED_I18N_COUNTRIES_ISO3 = Object.values(ISO2_TO_ISO3);

export interface ICountryCodeOption {
  code?: string | null;
  status?: string | null;
  has_dactilar?: boolean | null;
}

export function extractCountryCodeOptionsPayload(payload: unknown): ICountryCodeOption[] {
  if (Array.isArray(payload)) {
    return payload as ICountryCodeOption[];
  }

  if (payload && typeof payload === 'object') {
    const maybeData = (payload as { data?: unknown }).data;
    if (Array.isArray(maybeData)) {
      return maybeData as ICountryCodeOption[];
    }
  }

  return [];
}

export function getActiveIso3CodesFromCountriesResponse(countries: ICountryCodeOption[] | null | undefined): string[] {
  if (!countries) return [];

  return countries
    .filter((country) => country.status === undefined || country.status === null || country.status === 'ACTIVE')
    .map((country) => country.code?.toUpperCase())
    .filter((code): code is string => Boolean(code && /^[A-Z]{3}$/.test(code)));
}

export function getDactilarIso3CodesFromCountriesResponse(countries: ICountryCodeOption[] | null | undefined): string[] {
  if (!countries) return [];

  return getActiveIso3CodesFromCountriesResponse(countries.filter((country) => country.has_dactilar === true));
}

export function buildSupportedIso3CountryCodes(activeCountryCodes?: string[] | null): string[] {
  if (activeCountryCodes?.length) {
    return activeCountryCodes;
  }

  return SUPPORTED_I18N_COUNTRIES_ISO3;
}

export const ISO3_TO_ISO2: Record<string, string> = Object.entries(ISO2_TO_ISO3).reduce(
  (accumulator, [iso2, iso3]) => {
    accumulator[iso3] = iso2;
    return accumulator;
  },
  {} as Record<string, string>
);

export const toIso3 = (iso2: string | undefined | null): string => {
  if (!iso2) return DEFAULT_SIGNER_COUNTRY_ISO3;
  const upper = iso2.toUpperCase();
  // Si ya es alpha-3 (3 letras), devolverlo tal cual
  if (upper.length === 3) return upper;
  return ISO2_TO_ISO3[upper] ?? DEFAULT_SIGNER_COUNTRY_ISO3;
};

export const toIso2 = (value: string | undefined | null): string => {
  if (!value) return DEFAULT_PHONE_COUNTRY_ISO;
  const upper = value.toUpperCase();
  if (upper.length === 2) return upper;
  return ISO3_TO_ISO2[upper] ?? DEFAULT_PHONE_COUNTRY_ISO;
};

const PHONE_COUNTRY_INDEX: Record<string, PhoneCountry> = PHONE_COUNTRIES.reduce(
  (accumulator, country) => {
    accumulator[country.iso2] = country;
    return accumulator;
  },
  {} as Record<string, PhoneCountry>
);

export const getPhoneCountryByIso = (iso2: string): PhoneCountry | undefined => {
  if (!iso2) {
    return undefined;
  }

  return PHONE_COUNTRY_INDEX[iso2.toUpperCase()];
};

export const sanitizePhoneNumber = (value: string): string => value.replace(/[^0-9]/g, '');

/**
 * Construye el teléfono internacional (E.164) a partir de lo que el firmante
 * escribió en el input y el país seleccionado, deduplicando el dial code cuando
 * viene apilado dentro del número (ej. selector CL `+56` + input `565656...`).
 *
 * Solo colapsa el dial code cuando aparece repetido consecutivamente al inicio,
 * por lo que nunca mutila un número nacional que casualmente empiece con el
 * código. Reemplaza la heurística frágil `startsWith(dialDigits)` que apilaba el
 * código en cada round-trip. Devuelve '' si no hay dígitos.
 */
export const buildInternationalPhone = (rawPhone: string | null | undefined, iso: string | null | undefined): string => {
  const digits = sanitizePhoneNumber(rawPhone || '');
  if (!digits) return '';

  const country = getPhoneCountryByIso(toIso2(iso || DEFAULT_PHONE_COUNTRY_ISO));
  const code = (country?.dialCode || '').replace('+', '');

  if (!code) {
    return (rawPhone || '').trim().startsWith('+') ? `+${digits}` : digits;
  }

  let collapsed = digits;
  while (collapsed.startsWith(`${code}${code}`)) {
    collapsed = collapsed.slice(code.length);
  }
  const withCode = collapsed.startsWith(code) ? collapsed : `${code}${collapsed}`;
  return `+${withCode}`;
};

/**
 * Separa un teléfono almacenado en formato internacional (ej. `+5215512345678`)
 * en `{ iso2, nationalNumber }`, recuperando el país a partir del propio número.
 *
 * Resuelve el bug de round-trip: el número se guarda con el código de país
 * concatenado (`${dialCode}${digits}`); al recargarlo, si no se recupera el ISO,
 * el selector queda en CL y los dígitos del código real (ej. `52`) quedan dentro
 * del número. Con esto el número se mantiene independiente del selector: si trae
 * su propio código (ej. `+52`), se respeta tal cual.
 *
 * - `hintIso2` (opcional): ISO2/ISO3 conocido del firmante (phoneCountryIso o
 *   country_code). Tiene prioridad si el número arranca con su dialCode.
 * - La inferencia por dialCode solo se aplica a números en formato internacional
 *   (con `+`) para no mutilar números nacionales. Para mercados LATAM los
 *   dialCodes son únicos; en códigos compartidos (ej. +1) se usa el primero que
 *   matchee — por eso `hintIso2` es la fuente preferida cuando está disponible.
 */
export const splitInternationalPhone = (
  phone: string | null | undefined,
  hintIso2?: string | null
): { iso2: string; nationalNumber: string } => {
  if (!phone) {
    return { iso2: hintIso2 ? toIso2(hintIso2) : '', nationalNumber: '' };
  }

  const hadPlus = phone.trim().startsWith('+');
  const digits = sanitizePhoneNumber(phone);

  if (!digits) {
    return { iso2: hintIso2 ? toIso2(hintIso2) : '', nationalNumber: '' };
  }

  // 1) Si hay hint de país y el número arranca con su dialCode, usarlo.
  if (hintIso2) {
    const hintCountry = getPhoneCountryByIso(toIso2(hintIso2));
    if (hintCountry) {
      const code = hintCountry.dialCode.replace('+', '');
      if (digits.startsWith(code) && digits.length > code.length) {
        return { iso2: hintCountry.iso2, nationalNumber: digits.slice(code.length) };
      }
    }
  }

  // 2) Inferir el país por el dialCode más largo que matchee (solo si venía en
  //    formato internacional, para no romper números nacionales sin código).
  if (hadPlus) {
    let best: { iso2: string; codeLen: number } | null = null;
    for (const country of PHONE_COUNTRIES) {
      const code = country.dialCode.replace('+', '');
      if (digits.startsWith(code) && (!best || code.length > best.codeLen)) {
        best = { iso2: country.iso2, codeLen: code.length };
      }
    }
    if (best && digits.length > best.codeLen) {
      return { iso2: best.iso2, nationalNumber: digits.slice(best.codeLen) };
    }
  }

  // 3) No se pudo inferir el país: devolver los dígitos tal cual con el hint.
  return { iso2: hintIso2 ? toIso2(hintIso2) : '', nationalNumber: digits };
};
